// Modules
import { forwardRef, useState } from "react";
import { FormattedMessage } from "react-intl";
import PropTypes from "prop-types";
// Material-UI
import { AppBar, Button, Dialog, DialogContent, IconButton, Slide, Toolbar, Typography } from "@mui/material";
// Components
import AlertDialog from "./AlertDialog";
// Assets
import CloseIcon from "@mui/icons-material/Close";

// slide animation
const Transition = forwardRef((props, ref) => <Slide direction="left" ref={ref} {...props} />);
Transition.displayName = "Transition";

// ===============================|| UI DIALOG - FULL SCREEN ||=============================== //

function FullScreenDialog({
    action,
    children,
    handleCloseDialog,
    hasConfirmationOnClose = false,
    handleOnClose,
    handleSubmit,
    open,
    title
}) {
    const [openAlertDialog, setAlertDialogOpen] = useState(false);

    const handleClickOpenAlertDialog = () => {
        setAlertDialogOpen(true);
    };
    const handleCloseAlertDialog = () => {
        setAlertDialogOpen(false);
    };

    const handleClose = closeEvent => {
        if (closeEvent && hasConfirmationOnClose) {
            handleClickOpenAlertDialog();
        } else {
            handleCloseDialog && handleCloseDialog();
            handleOnClose && handleOnClose();
        }
    };

    return (
        <div>
            <Dialog fullScreen open={open} onClose={handleClose} TransitionComponent={Transition}>
                <form onSubmit={e => handleSubmit(e, { handleClose })}>
                    <AppBar sx={{ position: "relative" }}>
                        <Toolbar>
                            <IconButton
                                edge="start"
                                color="inherit"
                                onClick={handleClose}
                                aria-label="close"
                                size="large"
                            >
                                <CloseIcon />
                            </IconButton>

                            <Typography variant="h3" color="inherit" sx={{ ml: 2, flex: 1 }}>
                                {title}
                            </Typography>
                            <Button
                                autoFocus
                                color="inherit"
                                onClick={e => {
                                    action?.action && action.action(e);
                                }}
                                {...action?.props}
                            >
                                <FormattedMessage id={action?.label || "save"} />
                            </Button>
                        </Toolbar>
                    </AppBar>
                    <DialogContent sx={{ padding: "5px 24px" }}>{children}</DialogContent>
                </form>
            </Dialog>
            <AlertDialog
                actions={{
                    primary: {
                        action: () => {
                            handleCloseAlertDialog();
                            handleClose();
                        },
                        label: "yes"
                    },
                    secondary: {
                        action: handleCloseAlertDialog,
                        label: "no"
                    }
                }}
                open={openAlertDialog || false}
                handleClose={handleCloseAlertDialog}
                title="cancel-operation-confirmation"
            />
        </div>
    );
}

FullScreenDialog.propTypes = {
    action: PropTypes.shape({
        action: PropTypes.func,
        label: PropTypes.oneOfType([PropTypes.node, PropTypes.string]).isRequired,
        props: PropTypes.object
    }).isRequired,
    children: PropTypes.node,
    handleCloseDialog: PropTypes.func,
    hasConfirmationOnClose: PropTypes.bool,
    handleOnClose: PropTypes.func,
    handleSubmit: PropTypes.func,
    open: PropTypes.bool.isRequired,
    title: PropTypes.oneOfType([PropTypes.node, PropTypes.string]).isRequired
};

export default FullScreenDialog;
